import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

const TabsContainer = styled.ul<{ noBreakMobile?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
  ${({ noBreakMobile }) =>
    noBreakMobile &&
    css`
      display: flex;
      flex-wrap: nowrap;
      list-style: none;
      margin: 0;
      padding: 0;
    `}
`;

type TabStyleProps = {
  noBreakMobile?: boolean;
  isActive: boolean;
  isSmallText?: boolean;
  isLeftAligned?: boolean;
};

const Tab = styled.li<TabStyleProps>`
  border-bottom: 5px solid
    ${({ theme, isActive }) =>
      isActive ? theme.colors.jungle : theme.colors.mushroom};
  cursor: pointer;
  flex: 1 0 50%;
  font-size: 18px;
  padding: 14px;
  text-align: ${({ isLeftAligned }) => (isLeftAligned ? "left" : "center")};
  font-weight: ${({ isActive }) => isActive && "bold"};
  &:hover {
    background-color: ${({ theme, isActive }) =>
      !isActive && theme.colors.darkCream};
    border-bottom: ${({ theme, isActive }) =>
      !isActive && theme.colors.darkCream};
  }

  @media only screen and (min-width: 550px) {
    flex-basis: auto;
  }

  ${({ isSmallText, isActive, theme }) =>
    isSmallText &&
    css`
      font-size: 16px;
      color: ${isActive
        ? theme.colors.charcoal
        : theme.colors.opacity(theme.colors.charcoal, 0.6)};
      font-weight: ${isActive && "normal"};
    `};

  ${({ noBreakMobile }) =>
    noBreakMobile &&
    css`
      padding: 14px 3px;
      flex: auto;
    `}
`;

export type Tab = {
  title: string;
  url?: string;
  id?: string;
};

export type TabProps = {
  tabs: Tab[];
  active: string;
  smallText?: boolean;
  onSelectTab: (url: string | undefined, id: string | undefined) => void;
  isSmall?: boolean;
  noBreakMobile?: boolean;
  isLeftAligned?: boolean;
};

export const Tabs: React.FC<TabProps> = ({
  active,
  tabs,
  onSelectTab,
  smallText,
  noBreakMobile,
  isLeftAligned,
}) => {
  return (
    <TabsContainer noBreakMobile={noBreakMobile}>
      {tabs.map(({ title, url, id }, i) => {
        const isActive = active === title || active === id;
        return (
          <Tab
            noBreakMobile={noBreakMobile}
            isActive={isActive}
            isSmallText={smallText}
            isLeftAligned={isLeftAligned}
            key={i}
            onClick={(e) => {
              e.preventDefault();
              onSelectTab(url, id);
            }}
          >
            {title}
          </Tab>
        );
      })}
    </TabsContainer>
  );
};
